import React, { useState } from "react";
import { motion } from "framer-motion";

/**
 * صورة ذكية:
 * - بتتحمّل بس لما تقرّب من الشاشة (lazy) وبتظهر بـ fade ناعم أول ما تجهز
 * - لو الرابط الأول فشل بتجرب اللي بعده، ولو كلهم فشلوا بتعرض خلفية شيك بدل الفراغ
 * - priority: للصور اللي بتظهر أول ما الصفحة تفتح (بتتحمّل على طول)
 */
export const SmartImg = ({ sources, alt = "", className = "", priority = false, style, ...rest }) => {
  const list = Array.isArray(sources) ? sources : [sources];
  const [i, setI] = useState(0);
  const [loaded, setLoaded] = useState(false);

  if (i >= list.length) {
    return <div className={`img-fallback ${className}`} aria-hidden="true" />;
  }
  return (
    <motion.img
      key={list[i]}
      src={list[i]}
      alt={alt}
      className={className}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      draggable={false}
      onLoad={() => setLoaded(true)}
      onError={() => {
        setLoaded(false);
        setI((n) => n + 1);
      }}
      initial={false}
      animate={{ opacity: loaded ? 1 : 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={style}
      {...rest}
    />
  );
};
